/**
 * The gold pot moment's title card, once a game has won the pot: its words,
 * by where the coins went (a lamp's game pays the run's pot).
 */
export function goldPotCard(coins: number, intoRun: boolean): { title: string; sub: string } {
  const amount = `${coins.toLocaleString('en-GB')} coins`;
  return { title: 'GOLD POT!', sub: intoRun ? `${amount} go in your run pot` : `${amount} are yours` };
}
